<template>
  <div id="app">
    <div id="container" v-bind:class="size">
      <TheBanner/>
      <TheNavigation/>
      <transition name="slide" mode="out-in">
        <router-view/>
      </transition>
    </div>
  </div>
</template>

<script>
  import TheNavigation from "@/components/TheNavigation";
  import TheBanner from "@/components/TheBanner";

  export default {
    components: {
      TheNavigation,
      TheBanner
    },
    computed: {
      size() { return this.$mq }
    },
    watch: {
      '$route' (to, from) {
        document.title = (to.meta.title ? to.meta.title + ' | ' : '') + 'Gästehaus Erna'
      }
    }
  }
</script>

<style lang="scss">
@import url('https://fonts.googleapis.com/css2?family=Ubuntu&display=swap');
@import "@/assets/content.scss";

body {
  margin: 0;
  font-size: 1rem;
}

#app {
  font-family: Ubuntu, Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: left;
  color: #171717;
}

#container {
  display: flex;
  flex-direction: column;

  margin: 0 auto 50px;


  /* mobile: 600 */
  &.mobile {
    width: 100%;
  }

  /* tablet: 900 */
  &.tablet {
    width: 600px;
  }

  /* laptop: 1200 */
  &.laptop {
    width: 900px;
  }

  /* desktop: Infinity */
  &.desktop {
    width: 1200px;
  }


  &:not(.mobile) > * {
    margin-top: 10px;

    &:first-child {
      margin-top: 0;
    }
  }
}

#container:not(.mobile):not(.tablet) {
  .slide-enter-active,
  .slide-leave-active {
    transition: opacity .5s, transform .5s;
  }

  .slide-enter,
  .slide-leave-to {
    opacity: 0;
    transform: translateX(-5%);
  }
}
</style>
